const RichText = (props) => {
    
    const {
        text
    } = props;
    
    return (
        <div dangerouslySetInnerHTML={{__html: text}} />
    )
}

export default RichText;